import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useForm from "../../hooks/useForm";
import { getSellByBatchNo } from "../../redux/sell/sellSlice";
import _ from "../../util/lodash/lodash";
import { saveSellReturn } from "../../redux/sell-return/sellReturnSlice";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

const defaultForm = {
  batch_number: "",
  id: "",
  sale_id: "",
  return_date: "",
  product_id: "",
  quantity: 0,
  amount: 0,
  return_note: "",
  sale_item_id: "",
  created_by: "",
  created_date: "",
  created_ip: "",
  updated_by: "",
  updated_date: "",
  company_id: "",

  SellReturnChilds: [
    {
      id: "",
      product_id: "",
      quantity: 0,
      amount: 0,
      sale_item_id: "",
      returned_quantity: 0,
    },
  ],
  ItemDetails: [
    {
      id: 0,
      sale_id: "",
      product_id: "",
      sale_unit_id: "",
      quantity: 0,
      unit_sale_price: 0,
      discount_amount: 0,
      tax_amount: 0,
      sub_total: 0,
      rack_id: "",
      returned_quantity: 0,
    },
  ],
  Attachments: [],
};

export const SellReturn = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { form, resetForm, handleChange, setForm } = useForm(defaultForm);

  const searchedSell = useSelector((state) => state.sell.searchedSell);
  useEffect(() => {
    if (searchedSell) {
      const upForm = {
        batch_number: form.batch_number,
        ...searchedSell,
      };
      setForm({ ...upForm });
    }
  }, [searchedSell]);

  const handleSearchSell = () => {
    dispatch(getSellByBatchNo(form));
  };

  const handleReturn = async (e, item) => {
    e.preventDefault();
    const updateForm = {
      ...form,
      SellReturnChilds: [
        {
          product_id: item.product_id,
          quantity: item.quantity,
          returned_quantity: item.returned_quantity,
          amount: item.amount,
          sale_item_id: item.id,
        },
      ],
      ItemDetails: form && form.ItemDetails,
    };
    try {
      const res = await dispatch(saveSellReturn(updateForm));
      if (res && res.payload && res.payload.statusCode === 201) {
        toast.success("Returned Successfully");
        dispatch(getSellByBatchNo({ batch_number: form.batch_number }));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReturnQuantityChange = (e, index) => {
    const { name, value } = e.target;
    const updateForm = JSON.parse(JSON.stringify(form.ItemDetails));

    if (name === "returned_quantity") {
      if (
        Number(value) + Number(updateForm[index].total_in) >
        updateForm[index].quantity
      ) {
        updateForm[index].error =
          "Returned quantity cannot exceed selld quantity";
      } else {
        updateForm[index].error = null;
      }
      updateForm[index].returned_quantity = Number(value);
    }

    setForm({ ...form, ItemDetails: updateForm });
  };

  return (
    <div className="p-4">
      <div className="w-full flex flex-col gap-5 items-start">
        <TextField
          label={t("Sell No")}
          name="batch_number"
          value={form.batch_number || ""}
          onChange={handleChange}
          required
          error={form.batch_number === ""}
          placeholder="Enter Batch No to Search..."
          fullWidth
          margin="normal"
        />

        <Button
          variant="contained"
          color="secondary"
          onClick={handleSearchSell}
          disabled={form && form.batch_number === ""}
        >
          {t("view sell")}
        </Button>

        {form && form.id !== "" ? (
          <TableContainer component={Paper}>
            <Table size="medium">
              <TableHead>
                <TableRow>
                  {/* Define table header cells */}
                  <TableCell>Sell No</TableCell>
                  <TableCell>Product</TableCell>
                  <TableCell>Unit</TableCell>
                  <TableCell>Rack</TableCell>
                  <TableCell>Sold Quantity</TableCell>
                  <TableCell>Return Quantity</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {form &&
                  form.ItemDetails &&
                  form.ItemDetails.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.batch_no || ""}</TableCell>
                      <TableCell>{item.product_name || ""}</TableCell>
                      <TableCell>{item.unit_name || ""}</TableCell>
                      <TableCell>{item.rack_name || 0}</TableCell>
                      <TableCell>{item.quantity || 0}</TableCell>
                      <TableCell sx={{ width: "250px" }}>
                        {item.total_in > 0 && (
                          <Typography variant="caption">
                            Already Returned Quantity: {item.total_in}
                          </Typography>
                        )}
                        <TextField
                          label="Return Quantity"
                          name="returned_quantity"
                          variant="standard"
                          type="number"
                          value={item.returned_quantity}
                          onChange={(e) => handleReturnQuantityChange(e, index)}
                          required
                          error={item.error || item.returned_quantity <= 0}
                          helperText={item.error}
                          placeholder="Enter return quantity"
                          fullWidth
                          margin="normal"
                        />
                      </TableCell>
                      <TableCell>
                        {item.can_return ? (
                          <Button
                            variant="contained"
                            size="small"
                            disabled={item.error || item.returned_quantity <= 0}
                            onClick={(e) => handleReturn(e, item)}
                          >
                            Return
                          </Button>
                        ) : (
                          <Typography variant="caption">
                            Already returned full quantity
                          </Typography>
                        )}
                      </TableCell>
                      {/* Add more cells if needed */}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="h4">{t("No Sell Found")}</Typography>
        )}
      </div>
    </div>
  );
};
